module.exports = __webpack_public_path__ + "img/12.df196155.jpg";